import { useState, useRef, useCallback } from "react";
import { View, Pressable, StyleSheet } from "react-native";
import useAuth from "@/hooks/useAuth";
import Avatar from "@/components/Avatar";
import { ProfileMenu } from "./ProfileMenu";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { useToolTip } from "@/hooks/useToolTip";
import { HEADER } from "@/components/Header/constants";

export default function ProfileButton() {
  const { user } = useAuth();
  const { colors } = useTheme();
  const toolTip = useToolTip();
  const [isActive, setActive] = useState(false);
  const ref = useRef<View>(null);
  const isHovering = useRef(false);

  const handlePointerEnter = useCallback(() => {
    isHovering.current = true;
    toolTip.setToolTipContent(
      <View
        style={{
          backgroundColor: colors.background,
          paddingHorizontal: 8,
          paddingVertical: 4,
          borderRadius: 8,
          borderWidth: StyleSheet.hairlineWidth,
          borderColor: colors.border,
        }}
      >
        <ThemedText style={{ fontSize: 12 }}>Profile</ThemedText>
      </View>,
    );
    ref.current?.measureInWindow((x, y, w, h) => {
      if (!isHovering.current) return;
      const btnRight = x + (w || 36);
      const tooltipWidth = 60;
      toolTip.setLocation({ x: btnRight - tooltipWidth, y: y + (h || 0) + 4, width: tooltipWidth, height: 30 } as any);
      toolTip.setVisible(true);
    });
  }, [colors.background, colors.border, toolTip]);

  const handlePointerLeave = useCallback(() => {
    isHovering.current = false;
    toolTip.setVisible(false);
  }, [toolTip]);

  return (
    <View ref={ref} onPointerEnter={handlePointerEnter} onPointerLeave={handlePointerLeave}>
      <Pressable
        style={{ height: HEADER.ICON_SIZE, width: HEADER.ICON_SIZE, marginRight: 10, borderRadius: 999 }}
        onPress={() => {
          toolTip.setVisible(false);
          setActive(true);
        }}
      >
        <Avatar userId={user?.id} size={HEADER.ICON_SIZE} />
      </Pressable>
      <ProfileMenu visible={isActive} setVisible={setActive} />
    </View>
  );
}
